module.exports = __webpack_public_path__ + "img/1125-joy-manpuku.dd87daea.png";